import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Navigate } from "react-router-dom"

import Heading from "~/components/Heading/Heading"
import Button from "~/components/Button/Button"
import Sidebar from "~/components/Sidebar/Sidebar"
import TextField from "~/components/TextField/TextField"
import PageWithSidebar from "~/components/PageWithSidebar/PageWithSidebar"
import PageContent from "~/components/PageContent/PageContent"
import axios from "axios"
import { getUser, setUser, createAlert } from "~/store"
import { User } from "~/types"

function NewSpace() {
  const user = useSelector(getUser)
  const dispatch = useDispatch()
  const setStateUser = (user: User) => dispatch(setUser(user))
  const [redirect, setRedirect] = useState(false)
  const [spaceName, setSpaceName] = useState("")
  const [creating, setCreating] = useState(false)

  useEffect(() => {
    axios.get("/api/spaces/new").then((response) => {
      // Don't overwrite a name the user has started typing
      setSpaceName((currentName) => currentName || response.data.name)
    })
  }, [])

  const createSpace = (event: React.FormEvent) => {
    event.preventDefault()

    if (!user) return

    setCreating(true)

    const params = {
      space: {
        name: spaceName,
      },
    }

    axios
      .post("/api/spaces", params)
      .then(() => {
        setStateUser({ ...user, space_name: spaceName })
        setRedirect(true)
      })
      .catch((error) => {
        dispatch(
          createAlert({
            message: error.response.data.error.join(", "),
            type: "error",
          }),
        )

        setCreating(false)
      })
  }

  return redirect ? (
    <Navigate to={`/spaces/${spaceName}`} />
  ) : (
    <PageWithSidebar>
      <PageContent>
        <div>
          <Heading text="Let's create a new space" />
          <form>
            <TextField
              label="Space name"
              placeholder="my-space-name"
              value={spaceName}
              valueChanged={(newValue) => setSpaceName(newValue)}
              autofocus={true}
              regex={/[&/\\#,$~%.":*{}]/g}
              maxLength={50}
            />
            <Button
              text={creating ? "Creating..." : "Create"}
              style="primary"
              className="mt-20 float-right"
              onClick={createSpace}
              disabled={creating}
            />
          </form>
        </div>
      </PageContent>
      <Sidebar style="primary" />
    </PageWithSidebar>
  )
}

export default NewSpace
